import { InstanceDashboardStack } from 'component/navigation/instance';

export default function RankingEvalCustomRankersLayout() {
    return <InstanceDashboardStack />;
}
